import { ApolloClient } from '@apollo/client';
import { SKU_QUERY } from './gql';
import { canEditAdminRecord, canEditAdminSpaceId, canEditRecord } from 'helper/security';
import { IBoundToSpace, IUser } from 'types';

interface validateSkuUniqueExclude {
  id: number;
  query: 'listProducts' | 'listFacilities' | 'listProductBundles' | 'listServiceTypes';
}

export async function validateSkuUnique(client: ApolloClient<object>, spaceId: number, sku: string, exclude?: validateSkuUniqueExclude[]) {
  const resData = await client.query({
    query: SKU_QUERY,
    variables: {
      spaceId,
      sku,
    },
    fetchPolicy: 'network-only',
  });
  const skuCount =
    resData.data.listProducts.products.filter(p => (exclude || []).filter(fi => fi.query === 'listProducts').findIndex(fi => fi.id === p.id) < 0).length +
    resData.data.listFacilities.facilities.filter(f => (exclude || []).filter(fi => fi.query === 'listFacilities').findIndex(fi => fi.id === f.id) < 0).length +
    resData.data.listProductBundles.bundles.filter(b => (exclude || []).filter(fi => fi.query === 'listProductBundles').findIndex(fi => fi.id === b.id) < 0)
      .length +
    resData.data.listServiceTypes.serviceTypes.filter(s => (exclude || []).filter(fi => fi.query === 'listServiceTypes').findIndex(fi => fi.id === s.id) < 0)
      .length;

  return skuCount === 0;
}

export function canEditProductsRecord(user: IUser, record: IBoundToSpace & { isSystem: boolean, forLister: boolean }) {
  if (!canEditRecord(user, record)) return false;
  if (!user.isSeminargo && record.isSystem) return false;
  if (!user.isSeminargo && record.forLister) return false;
  return true;
}
export function canEditProductsTextRecord(user: IUser, record: IBoundToSpace & { isSystem: boolean, forLister: boolean }) {
  if (!canEditRecord(user, record)) return false;
  return true;
}
